export function initEkCategoriesSlider(root: ParentNode = document): void {
  const sections = root.querySelectorAll<HTMLElement>('.ek-categories-slider');
  if (!sections.length) return;

  sections.forEach((section) => {
    const sectionId = section.id.replace('ek-categories-slider-', '');
    const scrollContainer = section.querySelector<HTMLElement>(`#categories-nav-${sectionId}`);
    const leftContainer = section.querySelector<HTMLElement>(`#left-scroll-container-${sectionId}`);
    const rightContainer = section.querySelector<HTMLElement>(`#right-scroll-container-${sectionId}`);
    const leftBtn = section.querySelector<HTMLButtonElement>(`#scroll-left-btn-${sectionId}`);
    const rightBtn = section.querySelector<HTMLButtonElement>(`#scroll-right-btn-${sectionId}`);

    if (!scrollContainer || !leftContainer || !rightContainer || !leftBtn || !rightBtn) return;

    // Skip if already initialized
    if (scrollContainer.dataset.dragInit === 'true') return;
    scrollContainer.dataset.dragInit = 'true';

    const updateScrollIndicators = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      const maxScrollLeft = scrollWidth - clientWidth;

      if (scrollLeft > 10) {
        leftContainer.classList.remove('hidden');
      } else {
        leftContainer.classList.add('hidden');
      }

      if (scrollLeft < maxScrollLeft - 10) {
        rightContainer.classList.remove('hidden');
      } else {
        rightContainer.classList.add('hidden');
      }
    };

    scrollContainer.addEventListener('scroll', updateScrollIndicators);

    const scrollLeft = () => {
      const scrollAmount = scrollContainer.clientWidth * 0.8;
      scrollContainer.scrollTo({
        left: scrollContainer.scrollLeft - scrollAmount,
        behavior: 'smooth',
      });
    };

    const scrollRight = () => {
      const scrollAmount = scrollContainer.clientWidth * 0.8;
      scrollContainer.scrollTo({
        left: scrollContainer.scrollLeft + scrollAmount,
        behavior: 'smooth',
      });
    };

    leftBtn.addEventListener('click', scrollLeft);
    leftContainer.addEventListener('click', scrollLeft);

    rightBtn.addEventListener('click', scrollRight);
    rightContainer.addEventListener('click', scrollRight);

    // Drag to scroll functionality
    let isDown = false;
    let startX = 0;
    let scrollLeftStart = 0;
    let hasDragged = false;

    scrollContainer.style.cursor = 'grab';

    scrollContainer.addEventListener('mousedown', (e) => {
      // Only handle left mouse button
      if (e.button !== 0) return;
      
      isDown = true;
      hasDragged = false;
      scrollContainer.style.cursor = 'grabbing';
      scrollContainer.style.userSelect = 'none';
      startX = e.pageX - scrollContainer.offsetLeft;
      scrollLeftStart = scrollContainer.scrollLeft;
    });

    scrollContainer.addEventListener('mouseleave', () => {
      if (!isDown) return;
      isDown = false;
      scrollContainer.style.cursor = 'grab';
      scrollContainer.style.userSelect = '';
    });

    scrollContainer.addEventListener('mouseup', () => {
      isDown = false;
      scrollContainer.style.cursor = 'grab';
      scrollContainer.style.userSelect = '';
    });

    scrollContainer.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      
      const x = e.pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 1.5; // Multiplier for scroll speed
      
      if (Math.abs(walk) > 5) {
        hasDragged = true;
      }
      
      scrollContainer.scrollLeft = scrollLeftStart - walk;
    });

    // Prevent click on links after dragging
    scrollContainer.addEventListener('click', (e) => {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);

    requestAnimationFrame(() => {
      updateScrollIndicators();
      setTimeout(updateScrollIndicators, 100);
    });
  });
}

